import Nav from "@/components/Nav.jsx";
import Hero from "@/components/sections/Hero.jsx";
import BookBrief from "@/components/sections/BookBrief.jsx";
import About from "@/components/sections/About.jsx";
import Skills from "@/components/sections/Skills.jsx";
import Experience from "@/components/sections/Experience.jsx";
import Projects from "@/components/sections/Projects.jsx";
import FieldWork from "@/components/sections/FieldWork.jsx";
import Certifications from "@/components/sections/Certifications.jsx";
import Education from "@/components/sections/Education.jsx";
import Contact from "@/components/sections/Contact.jsx";
import Footer from "@/components/sections/Footer.jsx";

export default function Landing() {
  return (
    <main data-testid="landing-root" className="relative z-[3]">
      <Nav />
      <Hero />
      <BookBrief />
      <About />
      <Skills />
      <Experience />
      <Projects />
      <FieldWork />
      <Certifications />
      <Education />
      <Contact />
      <Footer />
    </main>
  );
}
